<template>
  <v-container fluid class="pa-0 pa-md-3">
    <!-- حالت دسکتاپ -->
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-row align="start">
        
        <!-- سمت راست: پیش‌نمایش -->
        <v-col cols="12" md="4" lg="5" class="d-flex flex-column sticky-preview">
          <v-card class="pa-4 flex-grow-1 d-flex flex-column align-center" outlined>
            <h3 class="mb-4 text-h6 font-weight-bold">پیش‌نمایش</h3>
            
            <template v-if="selectedModel">
               <v-btn 
                block 
                class="mt-auto btn-get-code rounded-lg" 
                @click="confirmAndEdit"
              >
                تأیید و استفاده از این الگو
                <v-icon right>mdi-check-circle-outline</v-icon>
              </v-btn>
              <div class="preview-container w-100 d-flex justify-center align-center flex-grow-1 my-4">
                <component
                  v-if="previewTheme"
                  :is="previewTheme"
                  v-model="previewData"
                  :data="previewData"
                  :orders.sync="previewOrders"
                />
              </div>
            </template>
            
            <template v-else>
              <div class="text-center text-muted mt-10 d-flex flex-column align-center justify-center h-100">
                <v-icon size="64" color="grey lighten-2">mdi-cellphone-dock</v-icon>
                <p class="mt-4 text-body-1">لطفاً یک الگو را از لیست انتخاب کنید تا پیش‌نمایش آن اینجا نمایش داده شود.</p>
              </div>
            </template>
          </v-card>
        </v-col>

        <!-- سمت چپ: لیست الگوها و فیلتر جستجو -->
        <v-col cols="12" md="8" lg="7">
          <v-card class="pa-4 h-100" outlined>
            <v-row align="center" class="mb-2">
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="searchQuery"
                  :items="categories"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  item-text="title"
                  label="جستجو در الگوها..."
                  outlined
                  @keyup.enter="getData(1)"
                  @change="getData(1)"            
                      />
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-chip color="primary" outlined small>
                  {{ cards.length }} مورد بارگذاری شده
                </v-chip>
              </v-col>
            </v-row>

            <v-divider class="mb-6"></v-divider>

            <v-row v-if="loading && cards.length === 0" class="mt-5">
              <v-col cols="12" class="text-center">
                <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
              </v-col>
            </v-row>

            <v-row v-else-if="cards.length">
             <v-col 
                v-for="item in cards" 
                :key="item.id" 
                class="mb-6 pa-2"
                cols="12" sm="4" md="3" lg="3"
              >
                <v-card 
                  flat
                  class="position-relative"
                  :style="selectedModel && selectedModel.id === item.id ? 'border: 2px solid var(--v-success-base); border-radius: 15px;' : 'border: 2px solid transparent; border-radius: 15px;'"
                >
                  <v-avatar
                    v-if="selectedModel && selectedModel.id === item.id"
                    color="success"
                    size="28"
                    class="elevation-2 position-absolute"
                    style="z-index: 3; top: -10px; left: -10px;"
                  >
                    <v-icon dark size="18">mdi-check</v-icon>
                  </v-avatar>

                  <div
                    :style="{
                      background: `url(${getCardImage(item) || '/img/default.webp'})`,
                      'background-size': 'cover',
                      'background-position': 'center',
                      'background-repeat': 'no-repeat',
                      height: '14rem',
                    }"
                    class="card-style p-0 position-relative"
                    @click="selectForPreview(item)"
                  >
                    <div
                      class="position-absolute"
                      style="right: 5px; top: 5px; z-index: 2"
                    >
                      <img 
                        :src="getProfileImage(item) || '/media/cr_logo.webp'"
                        @error="onImageError"
                        alt=""
                        class="rounded-circle border border-2 img-fluid bg-white"
                        width="50"
                        height="50"
                        style="object-fit: cover;"
                      />
                    </div>
                  </div>
                  
                  <v-card-subtitle class="text-center pb-0">{{ item.title || item.qr?.data?.data?.visitName }}</v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-else class="mt-5">
              <v-col cols="12" class="text-center">
                <v-icon size="50" color="grey lighten-1" class="mb-3">mdi-archive-cancel-outline</v-icon>
                <p class="text-muted">الگویی یافت نشد.</p>
              </v-col>
            </v-row>
            
            <!-- رفرنس برای Observer صفحه‌بندی -->
            <a id="dl" ref="dl"></a>
            <div v-if="loading && cards.length > 0" class="text-center w-100 my-4">
               <v-progress-circular indeterminate color="primary" size="30"></v-progress-circular>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <div class="mobile-layout pb-4">
        
        <v-sheet elevation="3" class="py-2 mb-3 bg-white">
          <v-slide-group
            v-if="cards.length > 0"
            class="pa-2"
            active-class="success"
            show-arrows
          >
            <v-slide-item v-for="item in cards" :key="item.id">
              <v-card
                class="ma-2 d-flex flex-column align-center justify-center text-center position-relative cursor-pointer"
                height="82"
                width="100"
                :style="{
                  border: (selectedModel && selectedModel.id === item.id) ? '2px solid var(--v-success-base)' : '1px solid #66646498',
                }"
                style="border-radius: 16px;"
                @click="selectForPreview(item)"

                elevation="0"
              >
                <!-- تیک انتخاب -->
                <v-avatar
                  v-if="selectedModel && selectedModel.id === item.id"
                  color="success"
                  size="22"
                  class="position-absolute"
                  style="top: -6px; left: -6px; z-index: 2;"
                >
                  <v-icon dark size="14">mdi-check</v-icon>
                </v-avatar>

                <!-- افزودن @error برای هندل کردن خطای 404 -->
                <img
                  :src="getProfileImage(item) || '/media/cr_logo.webp'"
                  @error="onImageError"
                  class="rounded-circle mb-1"
                  width="45"
                  height="45"
                  style="object-fit: cover; border: 3px solid #B4B4B759;"
                />
                
            <div class="text-caption font-weight-bold text-truncate w-100 px-1 primary--text" style="line-height: 1.2; text-shadow: 1px 1px 3px rgba(0,0,0,0.8);">
              {{ item.title || item.qr?.data?.data?.visitName ||'' }}
            </div>             
            </v-card>
            </v-slide-item>

            <v-slide-item>
              <div ref="dl" id="dl" class="d-flex align-center justify-center ma-2" style="width: 50px;">
                <v-progress-circular v-if="loading && next_page" indeterminate color="primary" size="24"></v-progress-circular>
              </div>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>

        <div class="px-3 mb-4 d-flex align-center">
          <v-autocomplete
            v-model="searchQuery"
            :items="categories"
            clear-icon="mdi-close-circle-outline"
            clearable
            hide-details
            dense
            item-text="title"
            label="جستجو در الگوها..."
            outlined
            background-color="white"
            style="border-radius: 12px;"
            @keyup.enter="getData(1)"
            @change="getData(1)"          />
          
          <!-- دکمه جستجو -->
          <v-btn 
            class="mr-2 btn-show rounded-pill" 
            style="border-radius: 12px; height: 40px; min-width: 40px; " 
            elevation="1"
            @click="getData(undefined)"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </div>


        <!-- پیش‌نمایش و دکمه -->
        <div class="preview-area px-3 d-flex flex-column align-center mb-10">
          <template v-if="selectedModel">
            <!-- <h4 class="mb-3 text-subtitle-1 font-weight-bold text-center">پیش‌نمایش الگو</h4> -->
            
            <v-btn 
              block 
              large 
              class="rounded-lg elevation-2 font-weight-bold mb-5 btn-get-code"
              @click="confirmAndEdit"
            >
              تأیید و استفاده از این الگو
              <v-icon right>mdi-check-circle-outline</v-icon>
            </v-btn>

            <div class="w-100 d-flex justify-center">
              <component
                v-if="previewTheme"
                :is="previewTheme"
                v-model="previewData"
                :data="previewData"
                :orders.sync="previewOrders"
              />
            </div>
          </template>
          <template v-else>
            <div class="text-center text-muted mt-8">
              <v-icon size="48" color="grey lighten-2">mdi-gesture-swipe-horizontal</v-icon>
              <p class="mt-4 text-body-2">لطفاً برای مشاهده پیش‌نمایش، یک الگو را از نوار بالا انتخاب کنید.</p>
            </div>
          </template>
        </div>

      </div>
    </template>

  </v-container>
</template>

<script>
import MobileViwer from "@/view/pages/qrland/components/mobileViwer";
import VisitThemeTwo from "@/view/pages/qrland/components/themes/visitThemeTwo";
import VisitThemeFlipped from "@/view/pages/qrland/components/themes/visitThemeFlipped";
import galleryMobile from "@/view/pages/otherQrTypes/giftGallery/components/galleryMobile";

export default {
  name: "modelsGallery",

  components: {
    MobileViwer,
    VisitThemeTwo,
    VisitThemeFlipped,
    galleryMobile
  },

  data() {
    return {
      categories: [],
      loading: false,
      cards: [], 
      searchQuery: '',
      observer: null,
      next_page: null,
      tableProps: {
        type: '',
      },
      selectedModel: null,
      previewTheme: 'MobileViwer',
      previewData: {},
      previewOrders: []
    }
  },

  computed: {
    iden(){
      return this.$route.query?.iden??'';
    },
    domain(){
      return this.$route.query?.domain??'';
    }
  },

  mounted() {
    if (this.$route.query.type) {
      this.tableProps.type = this.$route.query.type;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          this.next_page !== null &&
          !this.loading
        ) {
          if (this.$refs.dl) this.observer.unobserve(this.$refs.dl);
          this.getData(this.next_page);
        }
      });
    });
    
    this.getData(1);
  },

  methods: {
    onImageError(event) {
      event.target.src = '/media/cr_logo.webp';
    },
    onSearch() {
      this.getData(1);
    },

        getData(page = 1) {
      this.loading = true;
      
      if (page === 1) {
        this.cards = [];
      }

      this.$api
        .get(`/qr/template/list`, {
          params: {
            type: this.tableProps.type, 
            page: page,
            search: this.searchQuery,
          },
        })
        .then(({ data }) => {
          this.categories = data.data.categories;
          
          // ۱. ابتدا داده‌ها به لیست اضافه شوند تا شرط v-if در موبایل برقرار شود
          this.cards = [...this.cards, ...data.data.data];
          
          // ۲. وضعیت صفحه بعد را بررسی می‌کنیم
          if (data.data.has_next_page) {
            this.next_page = data.data.next_page;
            
            // ۳. با nextTick منتظر می‌مانیم تا DOM ساخته شود، سپس آبزرور را فعال می‌کنیم
            this.$nextTick(() => {
              if (this.$refs.dl) {
                this.observer.observe(this.$refs.dl);
              }
            });
          } else {
            this.next_page = null;
          }
        })
        .catch((reason) => {
          this.$modal.error(this.$t("error"), this.$t("data_fetch_error"));
        })
        .finally(() => {
          this.loading = false;
        });
    },


    getCardImage(item) {
      try {
        let rawData = item.data; 
        if (item.qr && item.qr.data) rawData = item.qr.data;
        const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : (rawData || {});
        const d = parsed.data || parsed;
        
        if (d?.photo?.headBackground) return d.photo.headBackground;
        if (d?.gallery?.[0]?.images?.[0]?.url) return d.gallery[0].images[0].url;
        if (d?.banner?.gallery?.[0]?.images?.[0]?.url) return d.banner.gallery[0].images[0].url;

        return item.image || null;
      } catch (e) {
        return item.image || null;
      }
    },

    getProfileImage(item) {
      try {
        let rawData = item.data; 
        if (item.qr && item.qr.data) rawData = item.qr.data;
        const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : (rawData || {});
        const d = parsed.data || parsed;
        
        return (d.photo && d.photo.profile) || item.profileImage || null;
      } catch (e) {
        return item.profileImage || null;
      }
    },

    selectForPreview(item) {
      this.selectedModel = item;
      try {
        let rawData = item.data; 
        if (item.qr && item.qr.data) {
          rawData = item.qr.data;
        }

        const parsedData = typeof rawData === 'string' ? JSON.parse(rawData) : (rawData || {});
        
        this.previewTheme = this.getPreviewTheme(item.type, parsedData.theme);
        this.previewData = parsedData.data || parsedData; 
        this.previewOrders = parsedData.orders || [];
        
      } catch (e) {
        this.previewTheme = this.getPreviewTheme(item.type,'');
        this.previewData = {};
        this.previewOrders = [];
      }
    },

    getPreviewTheme(type, savedTheme) {
      if (!type) return savedTheme || 'MobileViwer';
      const typeLower = type.toLowerCase();
      const themeMap = {
        visitcard: {
          default: 'VisitThemeTwo',
          allowed: ['MobileViwer', 'VisitThemeTwo', 'VisitThemeFlipped']
        },
        gift: {
          default: 'galleryMobile',
          allowed: ['galleryMobile']
        },
        menu: {
          default: 'MobileViwer',
          allowed: ['MobileViwer']
        }
      };
      const mapping = themeMap[typeLower];
      if (!mapping) {
        return savedTheme || 'MobileViwer';
      }
      if (savedTheme && mapping.allowed.includes(savedTheme)) {
        return savedTheme;
      }
      return mapping.default;
    },

    findEditPage(name, id, type) {
      const types = {
        visitcard: `qr/edit/${name}${!!id ? id : ""}`,
        visitcardpro: `qr/editpro/${name}${!!id ? id : ""}`,
        business: `qr/editBpage/${name}${!!id ? id : ""}`,
        goldlabel: `qr/goldlabel/${name}${!!id ? id : ""}`,
        commericial: `qr/editCpage/${name}${!!id ? id : ""}`,
        socialmedia: `qr/editSocial/${name}${!!id ? id : ""}`,
        consultationqr: `qr/consultationQrEdit/${name}${!!id ? id : ""}`,
        videogallery: `qr/editVideo/${name}${!!id ? id : ""}`,
        voicegallery: `qr/editVoice/${name}${!!id ? id : ""}`,
        voicegallerypro: `qr/editVoicePro/${name}${!!id ? id : ""}`,
        feedbackgallery: `qr/editFeedback/${name}${!!id ? id : ""}`,
        photogallery: `qr/editPhoto/${name}${!!id ? id : ""}`,
        singleproduct: `qr/product/${name}${!!id ? id : ""}`,
        labelproduct: `qr/labelproduct/${name}${!!id ? id : ""}`,
        menu: `qr/editMenu/${name}${!!id ? id : ""}`,
        bshop: `qr/editBShop/${name}${!!id ? id : ""}`,
        appointment: `qr/editAppointment/${name}${!!id ? id : ""}`,
        application: `qr/editApplication/${name}${!!id ? id : ""}`,
        insurance: `qr/insurance/${name}${!!id ? id : ""}`,
        wheel: `qr/luck-wheel/${name}${!!id ? id : ""}`,
        multicard: `qr/multicard/${name}${!!id ? id : ""}`,
        productpro: `qr/productPro/${name}${!!id ? id : ""}`,
        pdfgallery: `qr/editPdf/${name}${!!id ? id : ""}`,
        catalog: `qr/editcatalog/${name}${!!id ? id : ""}`,
        gift:`qr/editgift/${name}${!!id ? id : ""}`,
        text:`qr/editText/${name}${!!id ? id : ""}`,
        qrbale:`qr/editBale/${name}${!!id ? id : ""}`,
        qrrobika:`qr/editRobika/${name}${!!id ? id : ""}`,
        qreitaa:`qr/editEitaa/${name}${!!id ? id : ""}`,
        bankcard:`qr/bankcard/${name}${!!id ? id : ""}`,
        pricelabel: `qr/labelprice/${name}${!!id ? id : ""}`,
        attendanceqr: `qr/editattendance/${name}${!!id ? id : ""}`,     

      };
      // const excludedTypes = ['visitcard', 'visitcardpro', 'gift',"videogallery", "socialmedia", "photogallery","pdfgallery","menu", "business"];
      // if (!excludedTypes.includes(type?.trim()?.toLowerCase())) {
      //   console.log("true")
      // return types[type?.toLowerCase()]?.replace('?gateway=true','');
      // }
      // return `${types[type?.toLowerCase()]?.replace('?gateway=true','')}?gateway=true`;
     this.goto(types[type?.toLowerCase()]);
    },
    saveToQr(data) {
      const params = new URLSearchParams();
      for (const key in data) {
        if (data[key] !== undefined && data[key] !== null) {
          params.append(key, data[key]);
        }
      }
      return this.$api
        .put("/v1/testQr/update", params, { 
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then(() => {
          this.$toast.success("کیوار با موفقیت ویرایش شد");
          this.findEditPage(this.domain, this.iden, this.tableProps.type);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirmAndEdit() {
      if (this.selectedModel) {
        let targetData = this.selectedModel.qr ? this.selectedModel.qr.data : this.selectedModel.data;
        let targetQr = this.selectedModel.qr? this.selectedModel.qr.qr : this.selectedModel.qr;
        let payload = {
          type: this.tableProps.type || 'VisitCard',
          qrType: this.selectedModel.qrType || 'dynamic',
          title: this.selectedModel.title,
          domain: this.domain,
          identifier: this.iden,
          data: typeof targetData === 'string' ? targetData : JSON.stringify(targetData),
          qr:typeof targetQr === 'string'? targetQr: JSON.stringify(targetQr),
          qr_id: this.selectedModel.qr_id || this.selectedModel.id
        };
        console.log(payload,"payload");
        this.saveToQr(payload);
      }
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.sticky-preview {
  position: -webkit-sticky; 
  position: sticky;
  top: 85px;
  z-index: 10;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
}
.card-style {
  cursor: pointer;
  border-radius: 15px;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  height: 14rem;
  overflow: hidden;
}
.position-relative {
  position: relative !important;
}
.position-absolute {
  position: absolute !important;
}

/* کلاس‌های مخصوص موبایل */
.fixed-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 -4px 15px rgba(0, 0, 0, 0.08);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.mobile-layout {
  min-height: calc(100vh - 60px);
}
</style>
